<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div class="promo-banner critical-component-hide">
    <div class="promo-banner__inner container">
      <span
        class="visually-hidden"
        v-text="$string('general.site_header.promo_banner')"
      />

      <splide
        class="promo-banner__carousel"
        :class="{ 'promo-banner__carousel--active': blocks.length > 1 }"
        :has-track="false"
        :options="carouselConfig"
      >
        <splide-track>
          <splide-slide
            v-for="(block, index) of blocks"
            :key="`promo-${index}`"
            class="promo-banner__slide"
          >
            <div
              class="promo-banner__slide-content text-body-xs-bold text-center"
              v-html="getBlockText(block.title)"
            />
          </splide-slide>
        </splide-track>

        <div class="promo-banner__arrows splide__arrows">
          <button
            class="splide__arrow splide__arrow--prev"
            type="button"
          >
            <span
              class="visually-hidden"
              v-text="$string('accessibility.carousel.previous')"
            />

            <icon-chevron-left />
          </button>

          <button
            class="splide__arrow splide__arrow--next"
            type="button"
          >
            <span
              class="visually-hidden"
              v-text="$string('accessibility.carousel.next')"
            />

            <icon-chevron-right />
          </button>
        </div>
      </splide>

      <button
        class="promo-banner__country"
        type="button"
        @click="handleCountySwitcher"
      >
        <!-- eslint-disable-next-line vue/no-restricted-html-elements -->
        <img
          v-if="countryFlag"
          :key="`flag-${$variable('store.country')}`"
          class="promo-banner__country-flag"
          alt=""
          role="presentation"
          :src="countryFlag.src"
          :srcset="countryFlag.srcset"
        >

        <span class="promo-banner__country-country text-body-xs-regular visually-hidden">
          {{ $variable('store.countryName') }}
        </span>

        <icon-chevron-down />
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Promo banner (promo-banner)
 * -----------------------------------------------------------------------------
 * Promo banner template.
 * - Conditionally loaded when section has blocks.
 * - Scroll-snap is used for basic scrolling and JS is used to scroll slides.
 * - For more advanced functionality add carousel.
 *
 * @param {Object} autoplay - Autoplay settings.
 * @param {Array} blocks - Promo blocks.
 * @param {Object} liquid - Liquid section ID, used for theme editor events.
 *
 */
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'

import IconChevronDown from '~icons/directional-navigation/chevron/down.svg'
import IconChevronLeft from '~icons/directional-navigation/chevron/left.svg'
import IconChevronRight from '~icons/directional-navigation/chevron/right.svg'

export default {
  name: 'PromoBanner',

  components: {
    IconChevronDown,
    IconChevronLeft,
    IconChevronRight,
    Splide,
    SplideSlide,
    SplideTrack,
  },

  props: {
    autoplay: {
      type: Object,
      default: () => ({
        enable: false,
        timing: 5,
      }),
    },
    blocks: {
      type: Array,
      default: () => [],
    },
    // Needed for theme editor events
    // eslint-disable-next-line vue/no-unused-properties
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {
      currentSlide: 1,
      carouselConfig: {
        arrows: true,
        autoplay: this.autoplay.enable,
        interval: this.autoplay.timing * 1000,
        pagination: false,
        type: 'loop',
      },
    }
  },

  computed: {

    /**
     * Compute flag URL.
     * @returns {Object}
     */
    countryFlag() {
      const code = this.$variable('store.country').toLowerCase()

      if (!code) {
        return false
      }

      return {
        src: `https://flagcdn.com/w40/${code}.png`,
        srcset: `https://flagcdn.com/w40/${code}.png 40w, https://flagcdn.com/w80/${code}.png 80w, https://flagcdn.com/w160/${code}.png 160w`,
      }
    },
  },

  async mounted() {
    await this.$nextTick()
    cnvs.EventBus.emit('cnvs:update-site-header-height')
  },

  methods: {

    /**
     * Get block text.
     * - Applies text class to <a> elements.
     * @param {String} block - Block text.
     * @returns {String}
     */
    getBlockText(block) {
      return block
        .replaceAll('<a', '<a class="text-body-xs-bold"')
    },

    /**
     * Handle country switcher.
     */
    handleCountySwitcher() {
      // Add codes here
    },
  },
}
</script>

<style lang="scss">
@import './promo-banner';
</style>
